import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Droplets, House as Home, Leaf, Briefcase } from 'lucide-react';
import { Link } from "@/components/common/Link";
export default function YourGardenOurCare() {
  const services = [{
    icon: Droplets,
    title: "Flächenreinigung ohne Chemie",
    description: "Hochdruckreinigung von Terrassen, Einfahrten, Pflaster, Parkplätzen und Sportflächen – nur mit Wasser, umweltfreundlich."
  }, {
    icon: Home,
    title: "Hausmeisterservice",
    description: "Zuverlässige Hausmeistertätigkeiten im nicht handwerkspflichtigen Bereich für Privat und Gewerbe."
  }, {
    icon: Leaf,
    title: "Gartenpflege",
    description: "Professionelle Gartenpflege inkl. Hecken- und Rasenschnitt, Strauchschnitt und saisonale Pflege."
  }, {
    icon: Briefcase,
    title: "Büroorganisation",
    description: "Bürotätigkeiten und Hilfeleistungen im Bereich Büroorganisation für effiziente Abläufe."
  }];
  return <section className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {}
          <div className="order-2 lg:order-1 animate-fade-in-up">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/professional_service_activities.png" alt="Professional service activities including cleaning, facility management, gardening and office organization" className="w-full h-auto rounded-lg shadow-medium object-cover" />
          </div>

          {}
          <div className="order-1 lg:order-2 space-y-6 animate-fade-in-up-delay-100">
            <div className="space-y-4">
              <h1 className="text-4xl font-bold text-foreground leading-snug">
                Gartenpflege in Havixbeck und im Münsterland
              </h1>
              <p className="text-base text-muted-foreground leading-relaxed">
                Münsterland Industrieservice UG (haftungsbeschränkt) bietet umfassende Dienstleistungen im Münsterland: Flächenreinigung ohne chemische Zusätze, Hausmeistertätigkeiten im nicht handwerkspflichtigen Bereich, professionelle Gartenpflege sowie Bürotätigkeiten und Hilfeleistungen im Bereich Büroorganisation. Unsere erfahrenen Fachkräfte sorgen für höchste Qualität in allen Bereichen.
              </p>
            </div>

            {}
            <div className="space-y-4">
              {services.map((service, i) => {
              const Icon = service.icon;
              return <Card key={i} data-index={i} className="hover-lift border border-border">
                    <CardContent className="flex items-start gap-4 p-4">
                      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                        <Icon className="size-5 text-primary" />
                      </div>
                      <div className="space-y-1">
                        <h3 className="text-lg font-semibold text-foreground">
                          {service.title}
                        </h3>
                        <p className="text-sm text-muted-foreground leading-relaxed">
                          {service.description}
                        </p>
                      </div>
                    </CardContent>
                  </Card>;
            })}
            </div>

            <div className="pt-4">
              <Link to="/KontaktPage">
                <Button className="btn-primary">
                  Kostenloses Angebot anfordern
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}